import closeSVG from '../../../../../img/lnd30/close.svg';
import loadingSVG from '../../../../../img/lnd30/loading.gif';

export const loading = loadingSVG;
export const close = closeSVG;